import { render, staticRenderFns } from "./WakefieldCity.vue?vue&type=template&id=ba0f1036&scoped=true&"
import script from "./WakefieldCity.vue?vue&type=script&lang=js&"
export * from "./WakefieldCity.vue?vue&type=script&lang=js&"
import style0 from "./WakefieldCity.vue?vue&type=style&index=0&id=ba0f1036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0f1036",
  null
  
)

export default component.exports